import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseUrlImg, handleGetData } from '../../Api';
import { useStartupState } from '../../Providers/StartupState';
import InlineSVG from '../../components/InlineSVG/index';
import * as S from './style';

export const ContactUs = ({ top = null }) => {
  const [data, setData] = useState(null);

  const navigate = useNavigate();

  const { token } = useStartupState();

  useEffect(() => {
    if (token) {
      handleGetData(token, 'api/content/copasul/faleconosco/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        });
    }
  }, [token]);

  return (
    <>
      <S.ContactContainer>

        <S.ContactCard>
          <S.Title>{data?.ContatoComercial?.iv?.TituloGeral}</S.Title>
          <S.Text>
            {data?.ContatoComercial?.iv?.Subtitulo}
          </S.Text>
          <div>
            {data?.ContatoComercial?.iv?.listainformacao.map((item, i) => (
              <S.ContactItem key={i}>
                {/* <Phone size={24} /> */}
                <S.IconWrap>
                  <InlineSVG url={item.Imagem ? `${baseUrlImg}${item.Imagem}` : '/default-icon.svg'} />
                </S.IconWrap>
                <span>{item.Titulo}</span>
              </S.ContactItem>
            ))}
          </div>
          <S.Button onClick={() => navigate('/contato')}>Fale Conosco</S.Button>
        </S.ContactCard>

        <S.SideContent>
          <S.Kicker>{data?.TextoDetalhes1?.iv?.TituloGeral}</S.Kicker>
          {/* <S.SideTitle>Fale com o time comercial</S.SideTitle> */}
          <S.SideP>{data?.TextoDetalhes1?.iv?.Subtitulo}</S.SideP>
          {data?.TextoDetalhes1?.iv?.listainformacao.map((item, i) => (
            <S.SideList key={i}>
              <li>{item?.Titulo}</li>
            </S.SideList>
          ))}

          <S.Kicker>{data?.TextoDetalhes2?.iv?.TituloGeral}</S.Kicker>
          {data?.TextoDetalhes2?.iv?.listainformacao.map((item, i) => (
            <S.SideList key={i}>
              <li>{item?.Titulo}</li>
            </S.SideList>
          ))}
          {/* <S.Note>Respondemos em horário comercial. Tratamos seus dados conforme a LGPD.</S.Note> */}
        </S.SideContent>

      </S.ContactContainer>
    </>
  );
};
